// @flow
import createMaybeTransform from 'app/common/react/components/closeup/utils/createMaybeTransform';
import type {
  HasImages,
  HasImageOrig,
  MaybeAToMaybeAB,
} from 'app/common/react/components/closeup/utils/types';

type ToMaybeHasImageOrig = MaybeAToMaybeAB<HasImages, HasImageOrig>;

const hasImageOrig: ToMaybeHasImageOrig = createMaybeTransform((props) => {
  const { images } = props,
    imageOrig = images.orig,
    { url, width, height } = imageOrig || {};
  return url && !!width && !!height ? { ...props, imageOrig: { url, width, height } } : null;
});

export default hasImageOrig;
